// extracted by mini-css-extract-plugin
export default {"todoFormContainer":"TodoForm_todoFormContainer__fcyhR","addTodoIcon":"TodoForm_addTodoIcon__pNa6n"};